import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';

import { IconModule } from '@aw/shared/components/icon';

import { Module } from '@aw/prypco/enums';
import { RefDataPipe } from '@aw/prypco/pipes/reference-data';
import { ReferenceDataCatalogue } from '@aw/prypco/services/reference-data';

@Component({
  selector: 'aw-ory-auth-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RefDataPipe, RouterLink, IconModule],
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent {
  protected readonly Module = Module;
  protected readonly ReferenceDataCatalogue = ReferenceDataCatalogue;
}
